import { render, staticRenderFns } from "./BannerButtons.vue?vue&type=template&id=3cac9352&lang=html&"
import script from "./BannerButtons.vue?vue&type=script&lang=js&"
export * from "./BannerButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports